// extracted by mini-css-extract-plugin
export default {"container":"CatalogHeader-module__container--idbz9","back-button":"CatalogHeader-module__back-button--I2O2s"};